import { useState, useEffect, useCallback } from 'react';

export default function useScrollVisibility(threshold = 300) {
	const [isVisible, setIsVisible] = useState(false);

	const handleScroll = useCallback(() => {
		setIsVisible(window.scrollY > threshold);
	}, [threshold]);

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [handleScroll]);

	return isVisible;
}
